import { Notification } from '@copera/notification';
import { addListener } from '../common';

export const onNewNotification = addListener<{
  notification: Notification;
}>('/notification/new');

export const onNotificationUpdate = addListener<{
  notification: Notification;
}>('/notification/update');

export const onNotificationDelete = addListener<{
  notification: Notification;
}>('/notification/delete');
